
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/config';



@Injectable({
	providedIn: 'root'
})
export class KycService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private http: HttpClient
	) { }

	getKycState(): Observable<boolean>{
		return this.http.get(`${this.appConfig.apiEndpoint}/v2/dashboard/KYCState`)
		.pipe(map((data)=>{
			return data['data']['kycProviderIsActive'];
		}));
	}

}
